import Header26 from './Header26'
export default Header26
